

















import { Component, mixins } from '@niknevis/vue-modules'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import DialogMixin from '@/modules/common/dialog/mixins/DialogMixin'
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import { Prop } from 'vue-property-decorator'
import { BankAccountType } from '@/modules/bank-account/models/bank-account-resource.model'
import { DepositBankAccountStatus } from '@/modules/deposit-bank-account/models/deposit-bank-account-resource.model'
import AdminDepositBankAccountCreateForm
  from '@/modules/deposit-bank-account/components/admin/forms/AdminDepositBankAccountCreateForm.vue'

@Component({
  components: {
    AdminDepositBankAccountCreateForm,
    Modal
  }
})
export default class AdminCreateDepositBankAccountDialog extends mixins(DialogMixin) {
  @Prop({ required: true }) bankAccountTypesInPersian: { [key in BankAccountType]: string }
  @Prop({ required: true }) depositBankAccountStatusesInPersian: { [key in DepositBankAccountStatus]: string }

  $refs: {
    dialog: QDialog
  }

  modalVisibility: boolean = false
}
